module.exports = __webpack_public_path__ + "static/media/logo-strip.a21a0897.png";